import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/antd.css';

import { App } from 'App';
import reportWebVitals from './reportWebVitals';
import { GlobalStyles } from 'theme/Global.styles';
import { LayoutProvider } from 'shared/components/layout/useLayoutState';
import externalServices from 'utilities/externalServices/externalServices';

externalServices.init();

ReactDOM.render(
  <BrowserRouter>
    <LayoutProvider>
      <App />
    </LayoutProvider>
    <GlobalStyles />
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
